import React from 'react';
import PropTypes from 'prop-types';
import { useI18nContext } from '@procore/core-react';
import { useAppContext } from '@/react/context/AppContext';
import {
  MobileOverlay,
  MobileOverlayHeader,
  MobileOverlayBody,
  MobileOverlayFooter,
} from '@/react/components';
import MenuHeader from './MenuHeader';
import MenuBody from './MenuBody';
import MenuFooter from './MenuFooter';

const MobileMenu = ({ toggleMenu, isOpen }) => {
  const i18n = useI18nContext();
  const { header } = useAppContext();
  const {
    marketplaceBasePath,
    signInPath,
    currentCompany,
    currentUser,
    isSignedIn,
    signOutPath,
    changeCompanyPath,
  } = header;

  return (
    <MobileOverlay isOpen={isOpen} testId="mobile-menu">
      <MobileOverlayHeader onClose={toggleMenu}>
        <MenuHeader
          marketplaceBasePath={marketplaceBasePath}
          title={i18n.t('global.appMarketplace')}
        />
      </MobileOverlayHeader>

      <MobileOverlayBody>
        <MenuBody />
      </MobileOverlayBody>

      <MobileOverlayFooter>
        <MenuFooter
          isSignedIn={isSignedIn}
          signInPath={signInPath}
          currentUser={currentUser}
          currentCompany={currentCompany}
          changeCompanyPath={changeCompanyPath}
          signOutPath={signOutPath}
        />
      </MobileOverlayFooter>
    </MobileOverlay>
  );
};

MobileMenu.propTypes = {
  toggleMenu: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default MobileMenu;
